import { ReplyScheduleRepeatEnum, ReplyScheduleWeekDaysEnum } from '../api/gen/base'
import { NumberPostfixConfig } from '../components/NumberWithCorrectPostfix'

export const regularRequestRepeatOptions: {
    label: string
    value: ReplyScheduleRepeatEnum
}[] = [
    {
        label: 'Не повторяется',
        value: 'ONCE',
    },
    {
        label: 'Ежедневно',
        value: 'EVERYDAY',
    },
    {
        label: 'По дням недели',
        value: 'WEEK_DAYS',
    },
]

export const regularRequestsChipPostfix: NumberPostfixConfig = {
    endsWithOne: 'регулярный запрос',
    endsBetweenTwoAndFour: 'регулярных запроса',
    other: 'регулярных запросов',
}

export const REGULAR_REQUESTS_LIMIT_FOR_THREAD = 5

export const DAYS_OF_WEEK: {
    label: string
    value: ReplyScheduleWeekDaysEnum
}[] = [
    { label: 'Пн', value: 'MONDAY' },
    { label: 'Вт', value: 'TUESDAY' },
    { label: 'Ср', value: 'WEDNESDAY' },
    { label: 'Чт', value: 'THURSDAY' },
    { label: 'Пт', value: 'FRIDAY' },
    { label: 'Сб', value: 'SATURDAY' },
    { label: 'Вс', value: 'SUNDAY' },
]
